import { render } from "./Contact.vue?vue&type=template&id=7704f027"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=7704f027&lang=css"

import exportComponent from "D:\\Projects For Fun\\PortfolioWebsite\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__